import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { bootstrapAuth, isAuthenticated } from '../utils/auth';

export default function RequireAuth({ children }) {
  const location = useLocation();
  const [checking, setChecking] = useState(!isAuthenticated());
  const [allowed, setAllowed] = useState(isAuthenticated());

  useEffect(() => {
    let cancelled = false;

    if (isAuthenticated()) {
      setAllowed(true);
      setChecking(false);
      return undefined;
    }

    bootstrapAuth()
      .then((user) => {
        if (cancelled) return;
        setAllowed(Boolean(user));
      })
      .finally(() => {
        if (!cancelled) setChecking(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (checking) {
    return <div className="app-loading" role="status" aria-live="polite">Checking your account…</div>;
  }

  if (!allowed) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
